var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("welcome-homepage"),
      _vm._v(" "),
      _c("section", { staticClass: "gen-list" }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "gen-list-content" },
            [
              _vm._l(_vm.items, function(item) {
                return _c(
                  "li",
                  {
                    class: {
                      vid: item.media && item.media.store.id != 1,
                      multi: item.allVideos.length
                    }
                  },
                  [
                    _c("div", { staticClass: "preview" }, [
                      item.media &&
                      _vm.mediaUrl(item.media).indexOf("pdf") == -1
                        ? _c("img", {
                            attrs: { src: _vm.mediaUrl(item.media, item) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "video" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "cat" }, [
                        _vm._v(_vm._s(item.type && item.type.title))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat" }, [_vm._v(_vm._s(""))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _c("h5", [
                          _c("a", { attrs: { href: "" } }, [
                            (item.parent
                            ? item.parent.subtitle
                            : item.subtitle)
                              ? _c("em", [
                                  _vm._v(
                                    _vm._s(
                                      item.parent
                                        ? item.parent.subtitle
                                        : item.subtitle
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.formatTitle(item.title))
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        item.allVideos.length
                          ? _c(
                              "ul",
                              { staticClass: "related" },
                              [
                                _vm._l(item.allVideos, function(relVideo, ri) {
                                  return [
                                    ri < 3
                                      ? _c("li", [
                                          _vm._v(_vm._s(relVideo.title))
                                        ])
                                      : ri == 3
                                      ? _c("li", [
                                          _vm._v(
                                            "and " +
                                              _vm._s(
                                                item.allVideos.length - 3
                                              ) +
                                              " more..."
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _c("p", [_vm._v(_vm._s(_vm.introText(item)))]),
                        _vm._v(" "),
                        _c("date", [
                          _vm._v(
                            _vm._s(_vm.formatDate(item.created, "MMM Do, YYYY"))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l([_vm.paymentForVideo(item.id)], function(payment) {
                      return payment
                        ? _c("div", { staticClass: "payment" }, [
                            _c("p", { staticClass: "subscribed" }, [
                              _c("span", [_vm._v("Expires:")]),
                              _vm._v(" "),
                              _c("em", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      payment.endDate,
                                      "MMM Do YYYY"
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      staticClass: "wlink",
                      attrs: {
                        to: { name: "content", params: { id: item.id } }
                      }
                    })
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.items2, function(item) {
                return _c(
                  "li",
                  {
                    class: {
                      vid: item.media && item.media.store.id != 1,
                      multi: item.allVideos.length
                    }
                  },
                  [
                    _c("div", { staticClass: "preview" }, [
                      item.media &&
                      _vm.mediaUrl(item.media).indexOf("pdf") == -1
                        ? _c("img", {
                            attrs: { src: _vm.mediaUrl(item.media, item) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "video" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "cat" }, [
                        _vm._v(_vm._s(item.type && item.type.title))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "stat" }, [_vm._v(_vm._s(""))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _c("h5", [
                          _c("a", {
                            attrs: { href: "" },
                            domProps: {
                              innerHTML: _vm._s(_vm.formatTitle(item.title))
                            }
                          })
                        ]),
                        _vm._v(" "),
                        item.allVideos.length
                          ? _c(
                              "ul",
                              { staticClass: "related" },
                              [
                                _vm._l(item.allVideos, function(relVideo, ri) {
                                  return [
                                    ri < 3
                                      ? _c("li", [
                                          _vm._v(_vm._s(relVideo.title))
                                        ])
                                      : ri == 3
                                      ? _c("li", [
                                          _vm._v(
                                            "and " +
                                              _vm._s(
                                                item.allVideos.length - 3
                                              ) +
                                              " more..."
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _c("p", [_vm._v(_vm._s(_vm.introText(item)))]),
                        _vm._v(" "),
                        _c("date", [
                          _vm._v(
                            _vm._s(_vm.formatDate(item.created, "MMM Do, YYYY"))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l([_vm.paymentForVideo(item.id)], function(payment) {
                      return payment
                        ? _c("div", { staticClass: "payment" }, [
                            _c("p", { staticClass: "subscribed" }, [
                              _c("span", [_vm._v("Expires:")]),
                              _vm._v(" "),
                              _c("em", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      payment.endDate,
                                      "MMM Do YYYY"
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      staticClass: "wlink",
                      attrs: {
                        to: { name: "content", params: { id: item.id } }
                      }
                    })
                  ],
                  2
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.items.length && !_vm.all
            ? _c("div", { staticClass: "load-more" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadAll($event)
                      }
                    }
                  },
                  [_vm._v("Show all videos")]
                )
              ])
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gs-head" }, [
      _c("h2", [_vm._v("Latest Content")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }